module.exports = __webpack_public_path__ + "static/media/speakers.d11f410b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/speakers.svg
// module id = 3533
// module chunks = 7